import { Numeral } from "../../numeral/Numeral";
import { clausulas, cartas, consultas } from "../../legal/Content";
import { FirmaE } from "../../legal/Firma";
import { useEffect, useState } from "react";

export function PromissoryV2({
  basicInfo,
  userinfo
}) {

  const [fullName, setFullName] = useState("");


  useEffect(() => {
    let fullName = `${basicInfo?.firstname} ${basicInfo?.secondname} ${basicInfo?.firstlastname} ${basicInfo?.secondlastname}`;
    setFullName(fullName)
  }, [
    basicInfo?.firstname,
    basicInfo?.secondname,
    basicInfo?.firstlastname,
    basicInfo?.secondlastname,
  ])

  return (
    <>
      <div className="text-sm py-8 px-4">
        <div className="uppercase w-full flex gap-2 font-bold2">
          <div className="w-full">
            <div>Pagaré No.</div>
            <div>Valor</div>
            <div>Fecha de vencimiento</div>
          </div>
          <div className="w-full">
            <div>_ _ _ _ _ _ _ _</div>
            <div>_ _ _ _ _ _ _ _</div>
            <div>_ _ _ _ _ _ _ _</div>
          </div>
        </div>
        <div className="pt-4">
          <div>
            {fullName} identificado con cédula de
            ciudadanía No. {userinfo?.numberDocument}
            <Numeral className="mx-1" format={"0,0"} value={""} />{" "}
            {/*Completar cc */} obrando en la calidad de EL DEUDOR, por medio
            del presente PAGARÉ hago constar:
          </div>
        </div>
        <div>
          {clausulas.map((clausula, idx) => (
            <p key={idx} className="pt-4">
              <span className="font-bold2 uppercase"> {clausula.title} </span>
              {clausula.description}
            </p>
          ))}
        </div>
        <FirmaE />
        <div className="pt-8 uppercase text-center w-full font-bold2">
          <div className="w-full">
            <div>Carta de instrucciones</div>
          </div>
        </div>
        <div className="pt-4">
          {fullName}, identificado/a con cédula de ciudadanía No.
          <Numeral className="mx-1" format={"0,0"} value={userinfo?.numberDocument} /> quien en
          adelante me denominaré EL DEUDOR, me permito manifestar que autorizo
          en forma irrevocable a GRUPO EMPRESARIAL ANAV S.A.S., quien en
          adelante se denominará Galilea, o a su cesionario o a quien en el
          futuro represente sus derechos u ostente la calidad de ACREEDOR de los
          dineros que llegue a adeudar a Galilea en virtud de la utilización del
          cupo de crédito rotativo que me fue aprobado, para llenar sin previo
          aviso el pagaré a la orden con espacios en blanco que he suscrito a
          favor de Galilea, conforme a las siguientes instrucciones:
        </div>
        {cartas.map((carta, idx) => (
          <p key={idx} className="pt-4">
            <span className="font-bold2 uppercase"> {carta.title} </span>
            {carta.description}
          </p>
        ))}
        <FirmaE />
        <div className="pt-8 uppercase text-center w-full font-bold2">
          <div className="w-full">
            <div>
              AUTORIZACIÓN PARA LA CONSULTA, REPORTE Y PROCESAMIENTO DE DATOS
              CREDITICIOS, FINANCIEROS, COMERCIALES, DE SERVICIOS Y DE TERCEROS
              EN LAS CENTRALES DE INFORMACIÓN FINANCIERA
            </div>
          </div>
        </div>
        <div className="pt-4">
          {fullName}, identificado/a con cédula de ciudadanía No.
          <Numeral className="mx-1" format={"0,0"} value={userinfo?.numberDocument} /> obrando en la
          calidad de EL DEUDOR en mi calidad de titular de información, actuando
          libre y voluntariamente autorizo de manera expresa e irrevocable a
          GRUPO EMPRESARIAL ANAV S.A.S. - Galilea, o a quien represente sus
          derechos u ostente en el futuro a cualquier título la calidad de
          acreedor, a consultar, solicitar, suministrar, reportar, procesar y
          divulgar toda la información que se refiera a mi comportamiento
          crediticio, financiero y comercial a las Centrales de Información
          Financiera que administra la Asociación Bancaria y de entidades
          Financieras de Colombia o a quien represente sus derechos.
        </div>
        {consultas.map((consulta, idx) => (
          <p key={idx} className="pt-4">
            {consulta}
          </p>
        ))}
        <FirmaE />
      </div>
    </>
  );
}
